import React, { useState, useEffect } from 'react';

import GenericInputContainer from '../shared/GenericInputContainer';
import DisplayText from './DisplayText';
import EditText from './EditText';

const TextInputContainer = ({ initialValue: onPageLoadValue, syncChanges, isEditing, setIsEditing, isHovered, urlLink }) => {
    const [value, setValue] = useState(onPageLoadValue ? onPageLoadValue : '');
    const [initialValue, setInitialValue] = useState(onPageLoadValue ? onPageLoadValue : '');

    useEffect(() => {
        setValue(onPageLoadValue ? onPageLoadValue : '');
        setInitialValue(onPageLoadValue ? onPageLoadValue : '');
    }, [onPageLoadValue]);

    const isFieldNull = !value || !value.length;

    const valueHasntChanged = () => {
        return value === initialValue;
    };

    const handleSave = async () => {
        const syncValue = value === '' ? null : value;
        const response = await syncChanges(syncValue);
        if (response.success) {
            setInitialValue(value);
        }
        return response;
    };

    const handleCancel = () => {
        setValue(initialValue);
    };

    return (
        <GenericInputContainer {...{ isEditing, setIsEditing, isHovered, isFieldNull, handleSave, handleCancel, valueHasntChanged }}>
            <DisplayText {...{ value, urlLink }} />
            <EditText {...{ value, setValue }} />
        </GenericInputContainer>
    );
};

export default TextInputContainer;
